import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

const API_ENDPOINT = "https://babyu-sale.tech/backend_api/update-profile.php";

export const UpdateProfile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
   const [updateloading, setupdateLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    phone: "",
    email: "",
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      const [first, ...rest] = storedUser.full_name?.split(" ") || ["", ""];
      setUser(storedUser);
      setFormData((prev) => ({
        ...prev,
        email: storedUser.email || "",
        phone: storedUser.phone || "",
        username: storedUser.username || "",
        first_name: first,
        last_name: rest.join(" "),
      }));
    }
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleProfileUpdate = async () => {
    const full_name = `${formData.first_name} ${formData.last_name}`.trim();

    if (!formData.email) {
      toast.error("Email missing");
      return;
    }

    if (
      formData.username === user.username &&
      formData.phone === user.phone &&
      full_name === user.full_name
    ) {
      toast("No changes detected.");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: formData.email,
        },
        body: JSON.stringify({
          username: formData.username,
          phone: formData.phone,
          full_name,
        }),
      });

      const data = await res.json();
      if (data.status === "success") {
        toast.success("Profile updated!");
        localStorage.setItem(
          "user",
          JSON.stringify({ ...user, username: formData.username, phone: formData.phone, full_name })
        );
      } else {
        toast.error(data.message || "Update failed");
      }
    } catch (err) {
      toast.error("Network error. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

 const handlePasswordUpdate = async () => {
  if (!formData.old_password || !formData.new_password || !formData.confirm_password) {
    toast.error("All password fields are required.");
    return;
  }

  if (formData.new_password !== formData.confirm_password) {
    toast.error("Passwords do not match.");
    return;
  }

  try {
    setupdateLoading(true);
    const res = await fetch(API_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: formData.email,
      },
      body: JSON.stringify({
        old_password: formData.old_password,
        new_password: formData.new_password,
        confirm_password: formData.confirm_password, // ✅ Add this line
        full_name: `${formData.first_name} ${formData.last_name}`,
        username: formData.username,
        phone: formData.phone,
      }),
    });

    const data = await res.json();
    if (data.status === "success") {
      toast.success("Password updated!");
      setFormData((prev) => ({
        ...prev,
        old_password: "",
        new_password: "",
        confirm_password: "",
      }));
    } else {
      toast.error(data.message || "Password update failed");
    }
  } catch (err) {
    toast.error("Network error. Please try again.");
    console.error(err);
  } finally {
    setupdateLoading(false);
  }
};

  return (
    <div className="flex flex-col lg:flex-row items-center justify-center gap-6 w-full min-h-screen p-2 sm:p-4 overflow-x-hidden sm:mt-[-100px]">
      {/* Profile Update Section */}
      <div className="w-full max-w-full lg:max-w-[798px] flex-shrink-0">
        <div className="relative w-full min-h-[620px] sm:min-h-[420px] aspect-[798/567]">
          <div className="absolute inset-0 bg-[url('https://c.animaapp.com/mckvx84v4cwCjr/img/rectangle-45-1.svg')] bg-cover bg-center rounded-3xl overflow-hidden" />
          <img className="absolute top-[6%] left-[3%] w-[94%] h-[88%] object-cover rounded-3xl" alt="Freepik" src="https://c.animaapp.com/mckvx84v4cwCjr/img/freepik--the-style-is-candid-image-photography-with-natural--818-1.png" />
          <div className="absolute top-[6%] left-[3%] w-[94%] h-[88%] rounded-3xl bg-gradient-to-r from-[#2b111d]/90 via-[#1f1533]/90 to-[#10242f]/90" />

          <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center px-4 sm:px-4 md:px-10 pt-8 sm:pt-10">
            <div className="bg-[#1e1a2e] text-white text-lg sm:text-2xl font-semibold px-4 sm:px-6 py-2 rounded-full border-dashed border mb-4 text-center">
              Profile Settings
            </div>
            <div className="w-full max-w-2xl bg-transparent flex flex-col gap-4 sm:gap-6 rounded-3xl px-2 sm:px-4 py-6">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <label className="text-white text-sm sm:text-base">First Name</label>
                  <input value={formData.first_name} onChange={(e) => handleChange("first_name", e.target.value)} className="bg-[#3a335066] rounded-md p-2 text-[#bebebe] w-full" />
                </div>
                <div className="flex-1">
                  <label className="text-white text-sm sm:text-base">Last Name</label>
                  <input value={formData.last_name} onChange={(e) => handleChange("last_name", e.target.value)} className="bg-[#3a335066] rounded-md p-2 text-[#bebebe] w-full" />
                </div>
              </div>

              <div>
                <label className="text-white text-sm sm:text-base">Email</label>
                <input readOnly value={formData.email} className="bg-[#3a335066] rounded-md p-2 text-[#bebebe] w-full cursor-not-allowed" />
              </div>

              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <label className="text-white text-sm sm:text-base">Username</label>
                  <input value={formData.username} onChange={(e) => handleChange("username", e.target.value)} className="bg-[#3a335066] rounded-md p-2 text-[#bebebe] w-full" />
                </div>
                <div className="flex-1">
                  <label className="text-white text-sm sm:text-base">Phone</label>
                  <input value={formData.phone} onChange={(e) => handleChange("phone", e.target.value)} className="bg-[#3a335066] rounded-md p-2 text-[#bebebe] w-full" />
                </div>
              </div>

              <button onClick={handleProfileUpdate} disabled={loading} className="w-full sm:w-fit flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 rounded-full border-2 border-white shadow-md text-white bg-gradient-to-r from-pink-400 via-purple-400 to-sky-400 text-base sm:text-lg font-semibold mx-auto">
                {loading ? "Updating..." : "Update Profile"}
                <img className="w-[20px] sm:w-[25px] h-[20px] sm:h-[25px]" alt="Arrow right" src="https://c.animaapp.com/mckvx84v4cwCjr/img/arrow-right.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Password Section */}
      <div className="w-full max-w-full lg:max-w-[510px] flex-shrink-0">
        <div className="relative w-full min-h-[420px] aspect-[510/565]">
          <div className="absolute inset-0 bg-[url('https://c.animaapp.com/mckvx84v4cwCjr/img/rectangle-45.svg')] bg-cover bg-center rounded-3xl overflow-hidden" />
          <img className="absolute top-[6%] left-[3%] w-[94%] h-[88%] object-cover rounded-3xl" alt="Freepik" src="https://c.animaapp.com/mckvx84v4cwCjr/img/freepik--the-style-is-candid-image-photography-with-natural--818-1.png" />
          <div className="absolute top-[6%] left-[3%] w-[94%] h-[88%] rounded-3xl bg-gradient-to-r from-[#2b111d]/90 via-[#1f1533]/90 to-[#10242f]/90" />

          <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center px-4 md:px-10 pt-10">
            <div className="bg-[#1e1a2e] text-white text-xl font-semibold px-6 py-2 rounded-full border border-dashed text-center">
              Change Password
            </div>
            <div className="w-full max-w-md flex flex-col gap-4 mt-6">
              <div>
                <label className="text-white text-sm sm:text-base">Old Password</label>
                <input type="password" value={formData.old_password} onChange={(e) => handleChange("old_password", e.target.value)} className="h-[40px] sm:h-[52px] bg-[#3a335066] rounded-md p-2 text-[#bebebe] w-full" />
              </div>
              <div>
                <label className="text-white text-sm sm:text-base">New Password</label>
                <input type="password" value={formData.new_password} onChange={(e) => handleChange("new_password", e.target.value)} className="h-[40px] sm:h-[52px] bg-[#3a335066] rounded-md p-2 text-[#bebebe] w-full" />
              </div>
              <div>
                <label className="text-white text-sm sm:text-base">Confirm Password</label>
                <input type="password" value={formData.confirm_password} onChange={(e) => handleChange("confirm_password", e.target.value)} className="h-[40px] sm:h-[52px] bg-[#3a335066] rounded-md p-2 text-[#bebebe] w-full" />
              </div>

              <button onClick={handlePasswordUpdate} disabled={updateloading} className="w-full sm:w-fit flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 mt-3 rounded-full border-2 border-white shadow-md text-white bg-gradient-to-r from-pink-400 via-purple-400 to-sky-400 text-base sm:text-lg font-semibold mx-auto">
                {updateloading ? "Updating..." : "Update Password"}
                <img className="w-[20px] sm:w-[25px] h-[20px] sm:h-[25px]" alt="Arrow right" src="https://c.animaapp.com/mckvx84v4cwCjr/img/arrow-right.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
